/**
 * UI elements
 */
class FinHub_UI {
  constructor() {
    this.initTranslations();
    this.initSmoothScroll();
    this.initCustomInputNumber();
    this.initOpenNewOpininForm();
    this.initOwnContributionField();
    this.initLiabilityLabelField();
    this.initCheckAllBanksCheckboxs();
    this.initOpenSendMessageForm();
    this.initshowPhone();
    this.initAdvisorOpinionHelpful();
    this.initChangeFontSize();
    this.initFocusKeyboard();
    // this.initOnchangeSelect();
    this.showSearchAdvisorForm();
    this.lastAdvisorCityRequestID = null;
  }

  initTranslations () {
    this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 200
          }, 1000);
        }
      }
    });
  }

  initCustomInputNumber () {
    let quantity = $('.quantity');

    quantity.each(function() {
      let spinner = $(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

      btnUp.click(function() {
        let oldValue = parseFloat(input.val());
        let newVal = oldValue + 1;

        if (max > 0 && oldValue >= max) {
          newVal = oldValue;
        }

        input.val(newVal);
        input.trigger("change");
      });

      btnDown.click(function() {
        let oldValue = parseFloat(input.val());
        let newVal = oldValue - 1;

        if (oldValue <= min) {
          newVal = oldValue;
        }

        input.val(newVal);
        input.trigger("change");
      });
    });
  }

  initOpenNewOpininForm () {
    let openFormBtn = $('.advisor-opinions-open-form');

    if(!openFormBtn.length) {
      return
    }

    openFormBtn.on('click', (e) => {
      e.preventDefault();
      let addNewOpinionForm = $('.advisor-opinions-stats-form');

      openFormBtn.addClass('is-hidden');
      addNewOpinionForm.addClass('is-open');
    });
  }

  initOwnContributionField () {
    let field = $('input[name="own_contribution"]');
    let propertyValue = $('input[name="property_value"]');
    let label = $('.own-contribution-calculated-value');
    let wrapper = $('.own-contribution-wrapper');

    if (field.length && propertyValue.length && label.length && wrapper.length) {
      field.on('input', () => {
        let value = parseFloat(field.val());

        if (value >= 0 && value <= 100) {
          wrapper.removeClass('is-hidden');
          let calculatedValue = propertyValue.val() * (value / 100);
          calculatedValue = Number(calculatedValue).toFixed(2);
          label.text(calculatedValue);
        } else {
          wrapper.addClass('is-hidden');
        }
      });

      propertyValue.on('input', () => {
        let value = parseFloat(field.val());

        if (value >= 0 && value <= 100) {
          wrapper.removeClass('is-hidden');
          let calculatedValue = propertyValue.val() * (value / 100);
          calculatedValue = Number(calculatedValue).toFixed(2);
          label.text(calculatedValue);
        } else {
          wrapper.addClass('is-hidden');
        }
      });

      field.trigger('input');
    }
  }

  initLiabilityLabelField () {
    let field = $('input[name="liability_id"]');
    let instalmentAmountLabel = $('.instaltment-amount-label');

    if (field.length && instalmentAmountLabel.length) {
      field.change('input', (e) => {
        let fieldLabelName = $(e.target).attr('data-label');
        instalmentAmountLabel.text(fieldLabelName);
      });
    }
  }

  initCheckAllBanksCheckboxs () {
    let banksList = $('div[data-fh-name="show_banks"]');
    let field = banksList.find('#check-all');

    if (field.length) {
      field.click(function(){
        $('div[data-fh-name="show_banks"] input:checkbox').not(this).prop('checked', this.checked);
      });
    }
  }

  initOpenSendMessageForm () {
    let openSendMessageFormBtn = $('.send-message-button');

    if(!openSendMessageFormBtn.length) {
      return
    }

    openSendMessageFormBtn.on('click', (e) => {
      e.preventDefault();
      let sendMessageForm = $('.send-message-quick-form');

      openSendMessageFormBtn.addClass('is-hidden');
      sendMessageForm.addClass('is-open');
    });
  }

  initshowPhone () {
    $(document.body).on('click', function (e) {
      if (e.target.nodeName === 'SPAN' && $(e.target).attr('class') === 'block-advisers__item-phone') {
        $.ajax({
          url: $(e.target).parents('.show-contact-info').attr('data-url'),
          type: 'GET',
          dataType: 'json'
        }).done((response) => {
          $(e.target).find('.phone').html('<a href="tel:' + response.mobile_phone +'">' + response.mobile_phone + '</a>');
          $(e.target).find('.phone').addClass('is-open');
        }).fail((response) => {
          console.log(response);
        });
      }
    });

    $(document.body).on('click', function (e) {
      if (e.target.nodeName === 'SPAN' && $(e.target).attr('class') === 'block-advisers__item-mail') {
        $.ajax({
          url: $(e.target).parents('.show-contact-info').attr('data-url'),
          type: 'GET',
          dataType: 'json'
        }).done((response) => {
          $(e.target).find('.email').html('<a href="mailto:' + response.email +'">' + response.email + '</a>');
          $(e.target).find('.email').addClass('is-open');
        }).fail((response) => {
          console.log(response);
        });
      }
    });
  }

  initAdvisorOpinionHelpful () {
    $('.advisor-opinion-helpful-thumb-up a, .advisor-opinion-helpful-thumb-down a').on('click', (e) => {
      e.preventDefault();
      let recaptchaSiteKey = $('#advisor-opinions').attr('data-recaptcha-site-key');

      grecaptcha.ready(function() {
        grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function(recaptchaResponse) {
          let wrapper = $(e.target).parents('.advisor-opinion-helpful');
          let actionURL = $('#advisor-opinions').attr('data-thumb-url');
          let id = parseInt($(e.target).attr('data-id'), 10);
          let thumb = $(e.target).attr('data-thumb');

          if (thumb !== 'up' && thumb !== 'down') {
            return;
          }

          $.ajax({
            url: actionURL,
            type: 'POST',
            dataType: 'json',
            data: {
              id: id,
              thumb: thumb,
              'g-recaptcha-response': recaptchaResponse
            },
            beforeSend: () => {
              wrapper.find('.advisor-opinion-helpful-thumb-up').addClass('is-loading');
              wrapper.find('.advisor-opinion-helpful-thumb-down').addClass('is-loading');
            }
          }).done((response) => {
            wrapper.find('.advisor-opinion-helpful-thumb-up-count').text(response.thumb_up_count);
            wrapper.find('.advisor-opinion-helpful-thumb-down-count').text(response.thumb_down_count);
            wrapper.find('.advisor-opinion-helpful-thumb-up').removeClass('is-loading');
            wrapper.find('.advisor-opinion-helpful-thumb-down').removeClass('is-loading');
          }).fail(() => {
            wrapper.find('.advisor-opinion-helpful-thumb-up').removeClass('is-loading');
            wrapper.find('.advisor-opinion-helpful-thumb-down').removeClass('is-loading');
          });
        });
      });
    });
  }

  initChangeFontSize () {
    let htmlTag = $('html');
    let accessibilityBlock = $('.accessibility-block');
    let accessibilityBtnRegular = accessibilityBlock.find('button.normal-font');
    let accessibilityBtnLarge = accessibilityBlock.find('button.large-font');
    let accessibilityBtnHuge = accessibilityBlock.find('button.huge-font');

    accessibilityBtnRegular.click(function(e) {
      htmlTag.removeClass('large-font');
      htmlTag.removeClass('huge-font');
      window.localStorage.setItem('finhub-font-size', 'normal-font');
    });

    accessibilityBtnLarge.click(function(e) {
      htmlTag.addClass('large-font');
      htmlTag.removeClass('huge-font');
      htmlTag.removeClass('normal-font');
      window.localStorage.setItem('finhub-font-size', 'large-font');
    });

    accessibilityBtnHuge.click(function(e) {
      htmlTag.removeClass('large-font');
      htmlTag.addClass('huge-font');
      htmlTag.removeClass('normal-font');
      window.localStorage.setItem('finhub-font-size', 'huge-font');
    });
  }

  initFocusKeyboard () {
    let htmlTag = $('html');
    let selectWrapper = $('.select-wrapper');
    let selectLang = selectWrapper.find('.select-language');

    $('body').mousedown( function() {
        htmlTag.addClass('mouse');
        htmlTag.removeClass('keyboard');
        htmlTag.attr('data-whatintent', 'mouse');

        if (selectWrapper.length) {
            selectLang.attr("size", '');
        }
    });

    $('body').keydown( function(e) {
      if (e.keyCode === 9) {
        htmlTag.addClass('keyboard');
        htmlTag.removeClass('mouse');
        htmlTag.attr('data-whatintent', 'keyboard');

        if (selectWrapper.length) {
          let selectOptions = selectLang.find('option');

          selectLang.focus(function(e) {
            selectLang.attr("size", selectOptions.length);
          });

          selectLang.blur(function(e) {
            selectLang.attr("size", '');
          });
        }
      }
    });
  }

  initInfoAfterClickTargetBlank () {
    let extendLinks = $('a[target="_blank"]');

    for (let i = 0; i < extendLinks.length; i++) {
      let extendLink = extendLinks.eq(i);
      let extendLinkUrl = extendLink.attr('href');
      let extendExtension = extendLinkUrl.split('.').pop();

      if (extendExtension === 'pdf') {
        extendLink.on('click', function(e) {
          let response = confirm("Link prowadzi do pliku PDF i zostanie otwarty w nowym oknie.");

          if (!response) {
            e.preventDefault();
          }
        });
      } else {
        extendLink.on('click', function(e) {
          let response = confirm("Link zostanie otwarty w nowym oknie.");

          if (!response) {
            e.preventDefault();
          }
        });
      }
    }
  }

  initOnchangeSelect () {
    let sortSelect = $('#sort-select');

    sortSelect.on('change', function() {
      this.form.submit()
    });
  }

  showSearchAdvisorForm () {
    let openSearchAdvisorFormBtn = $('#show-form-button');

    if(!openSearchAdvisorFormBtn.length) {
      return
    }

    let advisorCityInput = $('#search-advisor-city');
    let advisorCityResults = $('#search-advisor-city-results');
    let debouncedDownload = this.debounce((phrase) => this.downloadCities(phrase), 750);

    advisorCityInput.on('input', (e) => {
      let searchPhrase = advisorCityInput.val();
      advisorCityResults.removeClass('is-hidden').addClass('is-loading');
      debouncedDownload(searchPhrase);
    });

    openSearchAdvisorFormBtn.on('click', (e) => {
      e.preventDefault();
      let SearchAdvisorForm = $('#show-form-form');
      SearchAdvisorForm.removeClass('hidden');
    });

    $(document.body).on('click', e => {
      $('#search-advisor-city-results').addClass('is-hidden');
      $('#search-advisor-city-results-content').html('');
    });

    $('#search-advisor-city-results').on('click', e => {
      e.stopPropagation();

      if (e.target.tagName === 'LI' && $(e.target).hasClass('search-advisor-city-results-item')) {
        $('#search-advisor-city').val($(e.target).text());
        $('#search-advisor-city-results').addClass('is-hidden');
        $('#search-advisor-city-results-content').html('');
        return;
      }
    });
  }

  downloadCities (searchPhrase) {
    if (searchPhrase.length < 3) {
      return;
    }

    let id = +new Date();
    this.lastAdvisorCityRequestID = id;

    $.ajax({
      url: '/advisers/search-places?term=' + encodeURIComponent(searchPhrase),
      type: 'POST'
    }).done((result) => {
      if (id === this.lastAdvisorCityRequestID) {
        $('#search-advisor-city-results').removeClass('is-loading');

        if (result.date.length) {
          $('#search-advisor-city-results-content').html('<ol class="search-advisor-city-results-items"><li class="search-advisor-city-results-item">' + result.date.join('</li><li class="search-advisor-city-results-item">') + '</li></ol>');
        } else {
          $('#search-advisor-city-results-content').html('<ol class="search-advisor-city-no-results"><li>' +  this.i18n.noresults + '&hellip;</li></ol>')
        }
      }
    }).fail(() => {
      $('#search-advisor-city-results').removeClass('is-loading');
      $('#search-advisor-city-results').addClass('is-hidden');
    });
  }

  debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
}
